import {inject, Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {baseUrl} from '../../../../core/constants/base-url';
import {PlanFactData, ProductNew, ProductOption, ReviewerNew} from '../types/table-data.types';

@Injectable({
  providedIn: 'root'
})
export class PlanFactApiService {
  private http: HttpClient = inject(HttpClient);

  public getMonth(monthNumber: number, year: number): Observable<PlanFactData> {
    const queryParams = {
      month: monthNumber,
      year: year
    }
    return this.http.get<PlanFactData>(`${baseUrl}/plan-fact-reports/month`, {params: queryParams})
  }

  public getProducts(monthNumber: number, year: number): Observable<Array<ProductNew>> {
    const queryParams = {
      month: monthNumber,
      year: year
    }
    return this.http.get<Array<ProductNew>>(`${baseUrl}/plan-fact-reports/products`, {params: queryParams})
  }

  public getProductOptions(monthNumber: number, year: number): Observable<Array<ProductOption>> {
    const queryParams = {
      month: monthNumber,
      year: year
    }

    return this.http.get<Array<ProductOption>>(`${baseUrl}/plan-fact-reports/product-options`, {params: queryParams})
  }

  public getReviewers(productPlanFactId: number): Observable<Array<ReviewerNew>> {
    const queryParams = { productPlanFactId }
    return this.http.get<Array<ReviewerNew>>(`${baseUrl}/plan-fact-reports/reviewers`, {params: queryParams});
  }

  public addProductToMonth(params: AddProductToMonthParams): Observable<void> {
    return this.http.post<void>(`${baseUrl}/plan-fact-reports/products`, params);
  }

  public addReviewerToProduct(params: AddReviewerToProduct): Observable<void> {
    return this.http.post<void>(`${baseUrl}/plan-fact-reports/reviewers`, params);
  }

  public addManagerToList(params: AddManagerToListParams): Observable<void> {
    return this.http.post<void>(`${baseUrl}/plan-fact-reports/managers`, params);
  }

  public updateValue(managerId: number, property: string, value: number): Observable<void> {
    const params = {[property]: value }

    return this.http.patch<void>(`${baseUrl}/plan-fact-reports/managers/${managerId}`, params);
  }

  public deleteProduct(id: number): Observable<void> {
    return this.http.delete<void>(`${baseUrl}/plan-fact-reports/products/${id}`)
  }

  public deleteReviewer(id: number): Observable<void> {
    return this.http.delete<void>(`${baseUrl}/plan-fact-reports/reviewers/${id}`)
  }

  public deleteManager(id: number): Observable<void> {
    return this.http.delete<void>(`${baseUrl}/plan-fact-reports/managers/${id}`)
  }
}

export type AddProductToMonthParams = {
  year: number;
  month: number;
  productId: number;
}

export type AddReviewerToProduct = {
  productPlanFactId: number;
  reviewerId: number;
}

export type AddManagerToListParams = {
  month: string;
  reviewerPlanFactId: number;
  managerId: number;
}
